/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'dva';
import { Table } from 'antd';

@connect(({ dutyArea }) => ({
  ...dutyArea,
}))


class TableList extends Component {

  handlePaginationChange = (page, pageSize) => {
    const { currentCondition, dispatch } = this.props;
    const { id } = currentCondition;
    dispatch({
      type: 'dutyArea/save',
      payload: {
        tableLoading: true
      }
    });
    dispatch({
      type: 'dutyArea/fetchTableLlist',
      params: {
        groupId: id,
        page,
        pageSize,
      }
    });
  }

  render() {
    const columns = [
      {
        title: '学校名称',
        dataIndex: 'schoolName',
        key: 'schoolName',
        render: text => {
          return text || '-';
        },
        width: 200,
      },
      {
        title: '学校类型',
        dataIndex: 'schoolNature',
        key: 'schoolNature',
        render: text => {
          return text || '-';
        },
        width: 120,
      },
      {
        title: '学校学段',
        dataIndex: 'schoolSection',
        key: 'schoolSection',
        render: text => {
          return text || '-';
        },
        width: 120,
      },
      {
        title: '督学人员数量',
        dataIndex: 'patrolNum',
        key: 'patrolNum',
        render: text => {
          return text || '-';
        },
        width: 120,
      },
      {
        title: '教师数量',
        dataIndex: 'teacherNum',
        key: 'teacherNum',
        render: text => {
          return text || '-';
        },
        width: 120,
      },
      {
        title: '学生数量',
        dataIndex: 'studentNum',
        key: 'studentNum',
        render: text => {
          return text || '-';
        },
        width: 120,
      },
    ]

    const { tableLoading, tableDataSource = [], page, totalElements } = this.props;

    // 分页器属性
    const pagination = {
      showQuickJumper: true,
      showSizeChanger: true,
      defaultCurrent: 1,
      current: page,
      defaultPageSize: 10,
      total: totalElements,
      onShowSizeChange: this.handlePaginationChange,
      onChange: this.handlePaginationChange,
      showTotal: () => `共${totalElements}条记录`,
    };

    return <Table
      scroll={{ x: 'max-content' }}
      dataSource={tableDataSource}
      columns={columns}
      loading={tableLoading}
      pagination={pagination}

    />;

  }
}

export default TableList
